if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList)
      for (let item of MutationList) {
        if (item.target.id === "AjaxCartForm") {
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
  setTimeout(() => {
    const variantInputs = document.querySelectorAll(
      '[bss-b2b-product-form="main"] .product-variant__container input'
    );
    if (variantInputs.length) {
      variantInputs.forEach((item) => {
        item.addEventListener("click", (e) => {
          const productForm = document.querySelector(
            '[bss-b2b-product-form="main"]'
          );
          BSS_B2B.observer.productSubject.notifyObserver(
            "VariantChange",
            "VariantSelectChange",
            { event: e, productForm }
          );
        });
      });
    }
  }, 2000);
}
